package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import io.ktor.client.*

class WalletApi(private val client: HttpClient) {

    suspend fun getWallet(): ApiResponse<WalletDto> {
        return client.apiGet("v1/users/me/wallet")
    }

    suspend fun checkout(request: WalletCheckoutRequest): ApiResponse<WalletCheckoutDto> {
        return client.apiPost("v1/users/me/wallet/checkout", request)
    }

    suspend fun confirmCheckout(request: WalletConfirmRequest): ApiResponse<WalletConfirmDto> {
        return client.apiPost("v1/users/me/wallet/checkout/confirm", request)
    }

    suspend fun getTransactions(limit: Int, offset: Int): ApiResponse<List<WalletTransactionDto>> {
        return client.apiGet(
            "v1/users/me/wallet/transactions",
            mapOf("limit" to limit.toString(), "offset" to offset.toString())
        )
    }
}
